export const MESSAGE_ALERT_HEADER_NAME = 'x-timoraapp-alert';
export const MESSAGE_ERROR_HEADER_NAME = 'x-timoraapp-error';
export const MESSAGE_PARAM_HEADER_NAME = 'x-timoraapp-params';

/**
 * Storage key for the JWT.
 *
 * **Do not rename this string.** The prefix is historical and reads like something to tidy up, but it is
 * the key already sitting in every admin's localStorage: changing it signs the whole team out on deploy
 * and buys nothing.
 */
export const AUTHENTICATION_TOKEN_KEY = 'jhi-authenticationToken';

export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
}
